module.exports = {
  // docker: {
  //   urlBase: 'http://localhost:3000/',
  //   urlApi: 'http://localhost:8000/api',
  // },
  local: {
    urlBase: 'http://localhost:3000/',
    urlApi: 'http://localhost:5001/api',
  },
  dev: {
    urlBase: 'https://cannl-dev.appti.ch',
    urlApi: 'https://cannl-dev.appti.ch/api',
  },
  uat: {
    urlBase: 'https://cannl-uat.appti.ch',
    urlApi: 'https://cannl-uat.appti.ch/api',
  },
  prd: {
    urlBase: 'https://cannapp.ch',
    urlApi: 'https://cannapp.ch/api',
  },
};
